import React from 'react'
import Breadcrumbs from './breadCrumbs/breadCrumbs'
import LeftSection from './leftSection'
import RightSection from './rightSection'
import DownloadBrochure from './rightSection/DownloadBrochure'
import MoreDetailsSection from './leftSection/moreDetails/MoreDetails'
import { useParams } from 'react-router-dom'
import useFetch from '../../../hooks/useFetch'
import { getPropertyById } from '../../../services/propertyService'
import MapView from './rightSection/mapView'
import LoadingComponent from '../../../Components/LoadingComponent/loading'

const PropertyDetailPage = () => {
    const {propertyId} = useParams()

    const { data, loading, error:fetchingError } = useFetch(
      () => getPropertyById(propertyId),
      [propertyId]
  );


  if (loading) {
    return (
            <LoadingComponent />
    );
}

if (fetchingError) {
    return (
        <div className="flex justify-center items-center h-screen text-red-500">
            Error fetching property details.
        </div>
    );
}



  return (
    <div className='pt-[150px] bg-[#f5f5f5]'>
      <Breadcrumbs propertyData={data}/>
      <div className='flex'>

        <div className='w-[70%]  min-h-screen '>
            <LeftSection propertyData={data}/>

        </div>
        <div className='w-[2%]'></div>
        <div className='w-[25%]'>
              <RightSection postedByData={data?.postedBy} propertyId={propertyId}/>
             {data?.brochure && <DownloadBrochure/>}
              <MapView locationDetails={data?.locationDetails}/>
        </div>
      </div>
    </div>
  )
}

export default PropertyDetailPage
